import { render, staticRenderFns } from "./accommodation.vue?vue&type=template&id=ca5ad594&scoped=true&"
import script from "./accommodation.vue?vue&type=script&lang=js&"
export * from "./accommodation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5ad594",
  null
  
)

export default component.exports